import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule' },
  { path: 'cirn2021', loadChildren: './cirn2021/cirn2021.module#Cirn2021PageModule' },
  { path: 'aimgo2021', loadChildren: './aimgo2021/aimgo2021.module#Aimgo2021PageModule' },
  { path: 'dsf2021cc', loadChildren: './dsf2021cc/dsf2021cc.module#Dsf2021ccPageModule' },
  { path: 'dsf2021sf', loadChildren: './dsf2021sf/dsf2021sf.module#Dsf2021sfPageModule' },
  { path: 'dsce2021', loadChildren: './dsce2021/dsce2021.module#Dsce2021PageModule' },
  { path: 'cdg2021', loadChildren: './cdg2021/cdg2021.module#Cdg2021PageModule' },
  { path: 'dcsa2021', loadChildren: './dcsa2021/dcsa2021.module#Dcsa2021PageModule' },
  { path: 'eco2021', loadChildren: './eco2021/eco2021.module#Eco2021PageModule' },
  { path: 'cpe2021', loadChildren: './cpe2021/cpe2021.module#Cpe2021PageModule' },
  { path: 'pes2021', loadChildren: './pes2021/pes2021.module#Pes2021PageModule' },
  { path: 'clim2021', loadChildren: './clim2021/clim2021.module#Clim2021PageModule' },
  { path: 'dcsa2022', loadChildren: './dcsa2022/dcsa2022.module#Dcsa2022PageModule' },
  { path: 'neo2022', loadChildren: './neo2022/neo2022.module#Neo2022PageModule' },
  { path: 'gine2022', loadChildren: './gine2022/gine2022.module#Gine2022PageModule' },
  { path: 'aimgo2022', loadChildren: './aimgo2022/aimgo2022.module#Aimgo2022PageModule' },
  { path: 'dsf2022', loadChildren: './dsf2022/dsf2022.module#Dsf2022PageModule' },
  { path: 'eco2022', loadChildren: './eco2022/eco2022.module#Eco2022PageModule' },  { path: 'cpe2022', loadChildren: './cpe2022/cpe2022.module#Cpe2022PageModule' },
  { path: 'dsf2022el', loadChildren: './dsf2022el/dsf2022el.module#Dsf2022elPageModule' },
  { path: 'cpmh2022', loadChildren: './cpmh2022/cpmh2022.module#Cpmh2022PageModule' },
  { path: 'eco2023', loadChildren: './eco2023/eco2023.module#Eco2023PageModule' },
  { path: 'aimgo2023', loadChildren: './aimgo2023/aimgo2023.module#Aimgo2023PageModule' },
  { path: 'dsf2023', loadChildren: './dsf2023/dsf2023.module#Dsf2023PageModule' },
  { path: 'clim2023', loadChildren: './clim2023/clim2023.module#Clim2023PageModule' },
  { path: 'dcsa2023', loadChildren: './dcsa2023/dcsa2023.module#Dcsa2023PageModule' },
  { path: 'clm2023', loadChildren: './clm2023/clm2023.module#Clm2023PageModule' },
  { path: 'eco2023v12', loadChildren: './eco2023v12/eco2023v12.module#Eco2023v12PageModule' },


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
